import { render } from "./AccountDashboard.vue?vue&type=template&id=b4787dfc&scoped=true"
import script from "./AccountDashboard.vue?vue&type=script&lang=js"
export * from "./AccountDashboard.vue?vue&type=script&lang=js"

import "./AccountDashboard.vue?vue&type=style&index=0&id=b4787dfc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4787dfc"]])

export default __exports__